import { Store } from 'pullstate';
import { PuzzleStoreBase, PuzzleStoreBaseDefaults, TruthsortingColors, TruthsortingStatement } from '../../../utils/types';

export type TruthsortingStoreType = PuzzleStoreBase & {
  slots: boolean[];
  statements: TruthsortingStatement[];
  solution: number[];
  // This is a conversion of the numerical sequence of the statements into their colors.
  // We should have just had the solution be this way originally in the server data but we didn't.
  // Since the `statements` property here is what the user reorders, we can't rely on the numbers
  // anymore since they refer to the original order of the statements - we wouldn't know which was which.
  // So we map those to their colors on load.
  solutionColors: TruthsortingColors[];
};

export const TruthsortingStore = new Store<TruthsortingStoreType>({
  ...PuzzleStoreBaseDefaults,
  slots: [],
  statements: [],
  solution: [],
  solutionColors: [],
});